(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
class OrderTracker {
  constructor() {
    this.form = document.getElementById('trackingForm');
    this.resultDiv = document.getElementById('trackingResult');
    this.errorDiv = document.getElementById('errorMessage');
    this.loadingState = false;
    
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (this.loadingState) return;

    const orderNumber = this.form.querySelector('[name="order_number"]').value.trim();
    const email = this.form.querySelector('[name="email"]').value.trim();

    if (!orderNumber || !email) {
      this.showError('Please fill in all fields');
      return;
    }

    this.setLoading(true);
    this.hideError();
    this.hideResult();

    try {
      const response = await fetch(`/account/orders/lookup?order_number=${orderNumber}&email=${email}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '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',
        },
        body: JSON.stringify({
          order: {
            order_number: orderNumber,
            email: email
          }
        })
      });

      if (!response.ok) {
        throw new Error('Order not found');
      }

      const data = await response.json();
      this.showOrderStatus(data.order);
    } catch (error) {
      this.showError('We couldn\'t find your order. Please check your order number and email address.');
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(loading) {
    this.loadingState = loading;
    const button = this.form.querySelector('button');
    button.disabled = loading;
    button.textContent = loading ? 'Loading...' : 'Track order';
  }

  showError(message) {
    this.errorDiv.textContent = message;
    this.errorDiv.style.display = 'block';
  }

  hideError() {
    this.errorDiv.style.display = 'none';
  }

  hideResult() {
    this.resultDiv.style.display = 'none';
  }

  calculateStatus(orderDate) {
    const now = new Date();
    const daysSinceOrder = Math.floor((now - orderDate) / (1000 * 60 * 60 * 24));
    
    const stages = [
      { name: "Getting your order ready", days: 0 },
      { name: "Packing everything with care", days: 1 },
      { name: "Your order's on its way", days: 2 },
      { name: "On the move. Almost there!", days: 3 },
      { name: "Your order has arrived!", days: 4 }
    ];
    
    let currentStageIndex = 0;
    for (let i = stages.length - 1; i >= 0; i--) {
      if (daysSinceOrder >= stages[i].days) {
        currentStageIndex = i;
        break;
      }
    }
    
    return {
      currentStageIndex,
      currentStage: stages[currentStageIndex]
    };
  }

  showOrderStatus(order) {
    const orderDate = new Date(order.created_at);
    const status = this.calculateStatus(orderDate);
    
    this.resultDiv.style.display = 'block';
    document.getElementById('statusText').textContent = status.currentStage.name;
    
    // Update progress bar
    const progressLine = document.querySelector('.progress-line-fill');
    progressLine.style.width = `${(status.currentStageIndex + 1) * 25}%`;
    
    // Update steps
    const steps = document.querySelectorAll('.step');
    steps.forEach((step, index) => {
      if (index <= status.currentStageIndex) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });

    // Update dates
    const estimatedDelivery = new Date(orderDate);
    estimatedDelivery.setDate(orderDate.getDate() + 4);
    
    document.getElementById('orderDate').textContent = orderDate.toLocaleDateString();
    document.getElementById('estimatedDelivery').textContent = estimatedDelivery.toLocaleDateString();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new OrderTracker();
});

  } catch(e) { console.error(e); }
})();
})();
